import {
  Button,
  Input,
  SelectSearch,
  Form,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import { Filter } from "lucide-react";
import { cleanEmptyStrings } from "@shared/hooks";
import { UserFilterData } from "../../schemas";

interface UsersFilterProps {
  onFilter: (data: Partial<UserFilterData>) => void;
  onClear: () => void;
  initialFilters?: Partial<UserFilterData>;
}

export const UsersFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: UsersFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<UserFilterData>({
    defaultValues: {
      name: initialFilters?.name ?? "",
      email: initialFilters?.email ?? "",
      role: initialFilters?.role ?? undefined,
    },
  });

  const handleFilter = (data: UserFilterData) => {
    onFilter(cleanEmptyStrings(data));
  };

  const handleClear = () => {
    form.reset({ name: "", email: "", role: undefined });
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("management.users.form.label.name")}:`}
            name="name"
            type="text"
            placeholder={translate(
              "management.users.form.placeholder.filterName",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.users.form.label.email")}:`}
            name="email"
            type="text"
            placeholder={translate(
              "management.users.form.placeholder.filterEmail",
            )}
          />
          <SelectSearch
            control={form.control}
            label={`${translate("management.users.form.label.role")}:`}
            name="role"
            placeholder={translate(
              "management.users.form.placeholder.filterRole",
            )}
            options={[
              { label: "Owner", value: "OWNER" },
              { label: "Owner Viewer", value: "OWNER VIEWER" },
              { label: "User", value: "USER" },
            ]}
            clearable
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("management.users.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("management.users.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
